import { useQuery } from "react-query"
import { AxiosError } from "axios"
import { getSwitchingSankeyInformation } from "components/CustomerBehavior/Switching/service"
import { hasValidFilters } from "components/Shared/utils/utils"
import { SwitchingSummarySankey } from "components/CustomerBehavior/Switching/interfaces"

import { RequestParameters } from "components/Shared/Filters/interfaces"

const SANKEY_QUERY_ID = "switchingSankeyFullInformation"
const FIELDS_TO_VALIDATE: Array<keyof RequestParameters> = [
	"departments",
	"categories",
	"vendors",
	"previousFrom",
	"previousTo",
	"currentFrom",
	"currentTo",
]

const useGetSankeyFullInformation = (filters: RequestParameters) => {
	const { isLoading, data, isError, error, refetch } = useQuery<
		SwitchingSummarySankey,
		AxiosError
	>([SANKEY_QUERY_ID, filters], () => getSwitchingSankeyInformation(filters), {
		enabled: hasValidFilters(filters, FIELDS_TO_VALIDATE),
		retry: false,
		refetchOnReconnect: false,
		refetchOnWindowFocus: false,
	})

	return { isLoading, data, isError, error, refetch }
}

export default useGetSankeyFullInformation
